import { hasMatchingConditions } from "./hasMatchingConditions";
import { getExceptions } from "./getExceptions";
import { ICalculateStampDutyParams } from "./interfaces";

const defaultContext = {
  country: undefined,
  isFirstTimeBuyer: false,
  isOnlyProperty: false,
};

export const findMapping = (
  searchContext: ICalculateStampDutyParams,
  mappings: Array<[any, any]>
) => (
  mappings.find((mapping) => {
    const condition = mapping[0];
    const conditionGivenDefaults = { ...defaultContext, ...condition };

    const searchContextWithDefaults = { ...defaultContext, ...searchContext };

    const isMatch = hasMatchingConditions(
      conditionGivenDefaults,
      searchContextWithDefaults,
    );

    return isMatch;
  })
);

export const findBandMapping = (
  searchContext: ICalculateStampDutyParams,
  mappings: Array<[any, any]>
) => {
  const exception = getExceptions(searchContext);

  if (exception) {
    return exception;
  }

  return findMapping(searchContext, mappings);
}
